import { CheckboxSelectionCallbackParams, ColDef } from "ag-grid-community";
import { BillingDailyNotesComponent } from "./billing-daily-notes.component";

export const colDefs = (component: BillingDailyNotesComponent): ColDef[] => [
  {
    maxWidth: 60,
    field: "selection",
    headerName: "",
    headerCheckboxSelection: true,
    checkboxSelection: (params: CheckboxSelectionCallbackParams<any>) => {
      return !!params.data && params.data.isSelectedItem !== true;
    },
    showDisabledCheckboxes: true,
    hide: !component.canAccess,
  },
  { field: "patientname", headerName: "Patient", sortable: true },
  { field: "discipline", headerName: "Disc", sortable: true },
  { field: "date", headerName: "Date of Bill/Daily Note", sortable: true },
  { field: "requestedby", headerName: "Assistant", sortable: true },
  {
    field: "view",
    headerName: "View Panel",
    cellRenderer: (params: any) => {
      const link = document.createElement("a");
      const isDisabled = params.data;
      link.innerHTML = "View&#x25BE;";
      link.style.cursor = "pointer";
      link.style.color = "blue";

      link.addEventListener("click", (event) => {
        if (params.node) {
          params.node.setExpanded(!params.node.expanded);
        }
        link.innerHTML = params.node.expanded ? "View&#x25B4;" : "View&#x25BE;";
      });
      return link;
    },
  },
];
